import { useEffect, useState } from "react";
import Cookies from "universal-cookie";

import OrderTable from "../modules/visitor/OrderTable";
import CustomerTable from "../modules/visitor/customers/CustomerTable";
import VisitorFilters from "../modules/visitor/VisitorFilters";
import DataPaging from "../modules/visitor/DataPaging";
import UserPaging from "../modules/visitor/UserPaging";

import errortrans from "../translate/error";
import env from "../env";
import tabletrans from "../translate/tables";

import { PieChart, pieArcLabelClasses } from "@mui/x-charts/PieChart";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";

import { normalPriceCount } from "../env";
import PostReq from "../utils/PostReq";

const Users = (props) => {
  const direction = props.lang ? props.lang.dir : errortrans.defaultDir;
  const lang = props.lang ? props.lang.lang : errortrans.defaultLang;

  const cookies = new Cookies();

  const token = cookies.get(env.cookieName);

  /**
   * گرفتن فیلترها از URL
   *
   * اگر purchase در URL وجود نداشته باشد:
   * false = فروش
   */
  const getFiltersFromUrl = () => {
    if (typeof window === "undefined") {
      return {
        purchase: false,
      };
    }

    const params = new URLSearchParams(window.location.search);

    const result = {};

    params.forEach((value, key) => {
      if (key === "purchase") {
        result[key] = value === "true";
        return;
      }

      if (value.includes(",")) {
        result[key] = value.split(",");
      } else {
        result[key] = value;
      }
    });

    // پیش‌فرض فروش
    if (result.purchase === undefined) {
      result.purchase = false;
    }

    return result;
  };

  const [filters, setFilters] = useState(() => {
    return getFiltersFromUrl();
  });

  const [categoryList, setCategoryList] = useState([]);
  const [manageList, setManageList] = useState([]);

  const [customers, setCustomers] = useState([]);
  const [orderList, setOrderList] = useState([]);

  const [totalPrice, setTotalPrice] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [totalWeight, setTotalWeight] = useState(0);

  const [categoryOptions, setCategoryOptions] = useState([]);
  const [manageOptions, setManageOptions] = useState([]);

  const [loadingReport, setLoadingReport] = useState(false);
  const [loadingUsers, setLoadingUsers] = useState(false);
  const [loadingData, setLoadingData] = useState(false);

  const [dataPagination, setDataPagination] = useState({
    page: 0,
    limit: 10,
  });

  const [userPagination, setUserPagination] = useState({
    page: 0,
    limit: 10,
  });

  const [dataSize, setDataSize] = useState(0);
  const [userSize, setUserSize] = useState(0);

  /**
   * ساخت Body مشترک برای تمام APIهای گزارش
   */
  const createBody = () => {
    return {
      manageIds: filters.manageIds
        ? Array.isArray(filters.manageIds)
          ? filters.manageIds
          : [filters.manageIds]
        : [],

      dateFrom: filters.dateFrom || "",

      dateTo: filters.dateTo || "",

      customerIds: filters.customerIds
        ? Array.isArray(filters.customerIds)
          ? filters.customerIds
          : [filters.customerIds]
        : [],

      catIds: filters.category
        ? Array.isArray(filters.category)
          ? filters.category
          : [filters.category]
        : [],

      status: filters.status
        ? Array.isArray(filters.status)
          ? filters.status
          : [filters.status]
        : [],

      // فروش = false
      // خرید = true
      purchase: filters.purchase === true,
    };
  };

  /**
   * ذخیره فیلترها در URL
   */
  const updateUrlWithFilters = (newFilters) => {
    if (typeof window === "undefined") {
      return;
    }

    const params = new URLSearchParams();

    Object.entries(newFilters).forEach(([key, value]) => {
      if (
        value === undefined ||
        value === null ||
        value === "" ||
        (Array.isArray(value) && value.length === 0)
      ) {
        return;
      }

      // purchase باید حتی وقتی false است در URL ذخیره شود
      if (key === "purchase") {
        params.set(key, value === true ? "true" : "false");
        return;
      }

      if (Array.isArray(value)) {
        params.set(key, value.join(","));
      } else {
        params.set(key, value);
      }
    });

    const newUrl = `${window.location.pathname}${
      params.toString() ? `?${params.toString()}` : ""
    }`;

    window.history.replaceState({}, "", newUrl);
  };

  /**
   * API:
   * POST /panel/report
   *
   * گزارش کلی
   */
  const fetchReport = async () => {
    setLoadingReport(true);

    try {
      const result = await PostReq({
        method: "POST",
        url: "/panel/report",
        body: createBody(),
      });

      if (!result) {
        throw new Error("خطا در دریافت گزارش");
      }

      const report = result?.result;

      const categories =
        report?.category?.map((item) => ({
          ...item,
          id: item.id,
          label: item.title,
          value: item.fullPrice,
        })) || [];

      const manages =
        report?.manage?.map((item) => ({
          ...item,
          id: item.id,
          label: item.title,
          value: item.fullPrice,
        })) || [];

      setCategoryList(categories);
      setManageList(manages);

      setCategoryOptions(report?.category || []);
      setManageOptions(report?.manage || []);

      setTotalPrice(report?.total?.totalPrice || 0);
      setTotalCount(report?.total?.totalCount || 0);
      setTotalWeight(report?.total?.totalWeight || 0);
    } catch (error) {
      console.error("Report API Error:", error);

      setCategoryList([]);
      setManageList([]);

      setCategoryOptions([]);
      setManageOptions([]);

      setTotalPrice(0);
      setTotalCount(0);
      setTotalWeight(0);
    } finally {
      setLoadingReport(false);
    }
  };

  /**
   * API:
   * POST /panel/report/user
   *
   * گزارش کاربران
   */
  const fetchUserReport = async () => {
    setLoadingUsers(true);

    try {
      const offset = userPagination.page * userPagination.limit;
      const pageSize = userPagination.limit;

      const result = await PostReq({
        method: "POST",
        url: `/panel/report/user?offset=${offset}&pageSize=${pageSize}`,
        body: createBody(),
      });

      if (!result) {
        throw new Error("خطا در دریافت گزارش کاربران");
      }

      setCustomers(result?.result || []);
      setUserSize(Number(result?.size || 0));
    } catch (error) {
      console.error("User Report API Error:", error);

      setCustomers([]);
      setUserSize(0);
    } finally {
      setLoadingUsers(false);
    }
  };

  /**
   * API:
   * POST /panel/report/data
   *
   * گزارش اطلاعات / سفارشات
   */
  const fetchDataReport = async () => {
    setLoadingData(true);

    try {
      const offset = dataPagination.page * dataPagination.limit;
      const pageSize = dataPagination.limit;

      const result = await PostReq({
        method: "POST",
        url: `/panel/report/data?offset=${offset}&pageSize=${pageSize}`,
        body: createBody(),
      });

      if (!result) {
        throw new Error("خطا در دریافت گزارش اطلاعات");
      }

      setOrderList(result?.data || []);
      setDataSize(Number(result?.size || 0));
    } catch (error) {
      console.error("Data Report API Error:", error);

      setOrderList([]);
      setDataSize(0);
    } finally {
      setLoadingData(false);
    }
  };

  /**
   * تغییر فیلترها
   */
  const handleFilterChange = (newFilters) => {
    const updatedFilters = {
      ...filters,
      ...newFilters,
    };

    setFilters(updatedFilters);

    setUserPagination({
      page: 0,
      limit: 10,
    });

    setDataPagination({
      page: 0,
      limit: 10,
    });

    updateUrlWithFilters(updatedFilters);
  };

  /**
   * کلیک روی نمودار دسته‌بندی
   */
  const handleCategoryClick = (item) => {
    if (!item?.id) {
      return;
    }

    const currentCategories = Array.isArray(filters.category)
      ? filters.category.map(String)
      : filters.category
        ? [String(filters.category)]
        : [];

    const itemId = String(item.id);

    const exists = currentCategories.includes(itemId);

    const updatedCategories = exists
      ? currentCategories.filter((id) => id !== itemId)
      : [...currentCategories, itemId];

    handleFilterChange({
      category: updatedCategories,
    });
  };

  /**
   * کلیک روی نمودار مدیریت
   */
  const handleManageClick = (item) => {
    if (!item?.id) {
      return;
    }

    const currentManages = Array.isArray(filters.manageIds)
      ? filters.manageIds.map(String)
      : filters.manageIds
        ? [String(filters.manageIds)]
        : [];

    const itemId = String(item.id);

    const exists = currentManages.includes(itemId);

    const updatedManages = exists
      ? currentManages.filter((id) => id !== itemId)
      : [...currentManages, itemId];

    handleFilterChange({
      manageIds: updatedManages,
    });
  };

  /**
   * گزارش کلی
   */
  useEffect(() => {
    fetchReport();
  }, [filters]);

  /**
   * گزارش کاربران
   */
  useEffect(() => {
    fetchUserReport();
  }, [filters, userPagination.page, userPagination.limit]);

  /**
   * گزارش اطلاعات
   */
  useEffect(() => {
    fetchDataReport();
  }, [filters, dataPagination.page, dataPagination.limit]);

  const categoryChartData = categoryList.map((item) => ({
    id: item.id,
    label: item.label,
    value: Number(item.value) || 0,
  }));

  const manageChartData = manageList.map((item) => ({
    id: item.id,
    label: item.label,
    value: Number(item.value) || 0,
  }));

  return (
    <div
      dir={direction}
      style={{
        width: "100%",
        padding: "1rem",
      }}
    >
      <h3>آنالیز فروش</h3>

      <VisitorFilters
        token={token}
        categoryOptions={categoryOptions}
        visitorOptions={manageOptions}
        currentFilters={filters}
        onFilterChange={handleFilterChange}
        lang={lang}
        direction={direction}
      />

      {/* گزارش کلی */}
      <Grid
        container
        spacing={2}
        sx={{
          marginBottom: 3,
        }}
      >
        <Grid item xs={12} md={4}>
          <Box
            sx={{
              backgroundColor: "#fff",
              borderRadius: 2,
              padding: 2,
              textAlign: "center",
              boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
            }}
          >
            <div>{tabletrans?.totalPrice?.[lang] || "مبلغ کل"}</div>
            <strong>{normalPriceCount(totalPrice)}</strong>
          </Box>
        </Grid>

        <Grid item xs={12} md={4}>
          <Box
            sx={{
              backgroundColor: "#fff",
              borderRadius: 2,
              padding: 2,
              textAlign: "center",
              boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
            }}
          >
            <div>{tabletrans?.totalCount?.[lang] || "تعداد کل"}</div>
            <strong>{totalCount}</strong>
          </Box>
        </Grid>

        <Grid item xs={12} md={4}>
          <Box
            sx={{
              backgroundColor: "#fff",
              borderRadius: 2,
              padding: 2,
              textAlign: "center",
              boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
            }}
          >
            <div>{"وزن کل"}</div>
            <strong>{totalWeight}</strong>
          </Box>
        </Grid>
      </Grid>

      <Grid container spacing={3}>
        {/* سمت دسته بندی / کاربران */}
        <Grid item xs={12} md={6}>
          <Box
            sx={{
              backgroundColor: "#fff",
              borderRadius: 2,
              padding: 2,
              marginBottom: 3,
            }}
          >
            <div
              style={{
                position: "relative",
                minHeight: 300,
              }}
            >
              {loadingReport ? (
                <Box
                  sx={{
                    minHeight: 300,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <CircularProgress />
                </Box>
              ) : categoryChartData.length > 0 ? (
                <PieChart
                  slotProps={{
                    legend: {
                      hidden: true,
                    },
                  }}
                  series={[
                    {
                      data: categoryChartData,
                      arcLabel: (item) => `${item.label}`,
                      arcLabelMinAngle: 20,
                    },
                  ]}
                  sx={{
                    [`& .${pieArcLabelClasses.root}`]: {
                      fontWeight: "bold",
                    },
                  }}
                  onItemClick={(event, item) => {
                    const clickedItem = categoryList[item.dataIndex];

                    if (clickedItem) {
                      handleCategoryClick(clickedItem);
                    }
                  }}
                  height={350}
                />
              ) : (
                <Box
                  sx={{
                    minHeight: 300,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  اطلاعاتی برای نمایش وجود ندارد
                </Box>
              )}
            </div>
          </Box>

          <Box
            sx={{
              backgroundColor: "#fff",
              borderRadius: 2,
              padding: 2,
            }}
          >
            {loadingUsers ? (
              <Box
                sx={{
                  minHeight: 200,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <CircularProgress />
              </Box>
            ) : (
              <div className="user-list">
                <CustomerTable
                  userList={customers}
                  lang={lang}
                  direction={direction}
                />

                <UserPaging
                  lang={lang}
                  page={userPagination.page}
                  limit={userPagination.limit}
                  size={userSize}
                  onChange={(page, limit) => {
                    setUserPagination({
                      page,
                      limit,
                    });
                  }}
                />
              </div>
            )}
          </Box>
        </Grid>

        {/* سمت مدیریت / سفارشات */}
        <Grid item xs={12} md={6}>
          <Box
            sx={{
              backgroundColor: "#fff",
              borderRadius: 2,
              padding: 2,
              marginBottom: 3,
            }}
          >
            <div
              style={{
                position: "relative",
                minHeight: 300,
              }}
            >
              {loadingReport ? (
                <Box
                  sx={{
                    minHeight: 300,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <CircularProgress />
                </Box>
              ) : manageChartData.length > 0 ? (
                <PieChart
                  slotProps={{
                    legend: {
                      hidden: true,
                    },
                  }}
                  series={[
                    {
                      data: manageChartData,
                      arcLabel: (item) => `${item.label}`,
                      arcLabelMinAngle: 20,
                    },
                  ]}
                  sx={{
                    [`& .${pieArcLabelClasses.root}`]: {
                      fontWeight: "bold",
                    },
                  }}
                  onItemClick={(event, item) => {
                    const clickedItem = manageList[item.dataIndex];

                    if (clickedItem) {
                      handleManageClick(clickedItem);
                    }
                  }}
                  height={350}
                />
              ) : (
                <Box
                  sx={{
                    minHeight: 300,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  اطلاعاتی برای نمایش وجود ندارد
                </Box>
              )}
            </div>
          </Box>

          <Box
            sx={{
              backgroundColor: "#fff",
              borderRadius: 2,
              padding: 2,
            }}
          >
            {loadingData ? (
              <Box
                sx={{
                  minHeight: 200,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <CircularProgress />
              </Box>
            ) : Array.isArray(orderList) ? (
              <div className="user-list">
                <OrderTable
                  content={orderList}
                  lang={lang}
                  direction={direction}
                />

                <DataPaging
                  page={dataPagination.page}
                  limit={dataPagination.limit}
                  size={dataSize}
                  lang={lang}
                  onChange={(page, limit) => {
                    setDataPagination({
                      page,
                      limit,
                    });
                  }}
                />
              </div>
            ) : null}
          </Box>
        </Grid>
      </Grid>
    </div>
  );
};

export default Users;
